import { WorkPackage } from '@bechtel/types';
import { createContext, FC, PropsWithChildren, useContext } from 'react';

const WorkPackageContextPrivate = createContext<WorkPackageContextProps>({ id: '', tag: '' });

const { Provider } = WorkPackageContextPrivate;

export const useWorkPackage = () => {
  return useContext(WorkPackageContextPrivate);
};

interface WorkPackageContextProps {
  id: WorkPackage['id'];
  tag: WorkPackage['tag'];
  startDate?: WorkPackage['startDate'];
  endDate?: WorkPackage['endDate'];
  assignedCrewMembers?: WorkPackage['primaryOwners'];
  facilities?: WorkPackage['facilities'];
  primaryOwners?: WorkPackage['primaryOwners'];
  secondaryOwners?: WorkPackage['secondaryOwners'];
  otherOwners?: WorkPackage['otherOwners'];
}

export const WorkPackageContext: FC<PropsWithChildren<WorkPackageContextProps>> = ({
  children,
  ...workPackageProps
}) => {
  return <Provider value={workPackageProps}>{children}</Provider>;
};
